import { render, staticRenderFns } from "./PumaNew.vue?vue&type=template&id=10f173b6&"
import script from "./PumaNew.vue?vue&type=script&lang=js&"
export * from "./PumaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports